import { render, staticRenderFns } from "./user_ad_card.vue?vue&type=template&id=bbac07f8&"
import script from "./user_ad_card.vue?vue&type=script&lang=js&"
export * from "./user_ad_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports